import React from 'react';
import { Form, Row, Col, Card } from 'react-bootstrap';
import Select from 'react-select';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

// W-0626 — Filtros: GE obrigatório (auto-select se 1 item, paridade SetaGE),
// Família/Empreendimento opcional (carrega ao selecionar o GE).
const PainelFiltros = ({
  values,
  errors,
  touched,
  setFieldValue,
  gruposEmpresa,
  familias,
  carregandoFamilias,
  onChangeGrupoEmpresa,
}) => {
  const geOptions = (gruposEmpresa || []).map((g) => ({
    value: g.codigo,
    label: g.apelido,
  }));

  const familiaOptions = (familias || []).map((f) => ({
    value: f.codigo_familia,
    label: f.nome_da_familia,
  }));

  const geSelectValue =
    geOptions.find((o) => o.value === values.codigoGrupoEmpresa) || null;

  const familiaSelectValue =
    familiaOptions.find((o) => o.value === values.codigoFamilia) || null;

  const renderError = (field) =>
    touched[field] && errors[field] ? (
      <div className="text-danger small mt-1">{errors[field]}</div>
    ) : null;

  return (
    <Card className="mb-3 shadow-sm">
      <Card.Header style={{ backgroundColor: '#0747a6', color: '#fff' }}>
        <strong>Filtros</strong>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col xs={12} md={6}>
            <Form.Group>
              <Form.Label>Grupo de Empresa *</Form.Label>
              <Select
                styles={customStyles}
                components={{ DropdownIndicator }}
                options={geOptions}
                value={geSelectValue}
                onChange={(opt) =>
                  onChangeGrupoEmpresa(opt ? opt.value : null)
                }
                placeholder="Selecione..."
                noOptionsMessage={() => 'Nenhum GE encontrado'}
                isClearable
              />
              {renderError('codigoGrupoEmpresa')}
            </Form.Group>
          </Col>
          <Col xs={12} md={6}>
            <Form.Group>
              <Form.Label>Família / Empreendimento</Form.Label>
              <Select
                styles={customStyles}
                components={{ DropdownIndicator }}
                options={familiaOptions}
                value={familiaSelectValue}
                onChange={(opt) =>
                  setFieldValue('codigoFamilia', opt ? opt.value : null)
                }
                placeholder={
                  values.codigoGrupoEmpresa
                    ? 'Todas as famílias'
                    : 'Selecione o GE primeiro'
                }
                noOptionsMessage={() => 'Nenhuma família encontrada'}
                isDisabled={!values.codigoGrupoEmpresa || carregandoFamilias}
                isLoading={carregandoFamilias}
                isClearable
              />
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default PainelFiltros;
